store.price = {};
store.price._format = {
	sign: "kr.",
	numDecs: 0,
	sepDec: '.',
	sepThou: ',',
	signLeft: false,
	space: true
};
store.price.setFormat = function(format) {
	store.price._format = format;
};
store.price.format = function(value) {
	var ret;
	var f = store.price._format;
	ret = store.numberFormat(value, f.numDecs, f.sepThou, f.sepDec);
	var symbol = f.sign;
	var sp = (f.space > 0) ? ' ': '';
	if (f.signLeft > 0) {
		ret = symbol + sp + ret;
	}
	else {
		ret = ret + sp + symbol;
	}
	return ret;
};
